import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import {
  FaGoogle,
  FaFacebook,
  FaApple,
  FaEye,
  FaEyeSlash,
} from "react-icons/fa";
import Cookies from "js-cookie";
import config from "../../config";
import PopupMessage from "../layouts/PopupMessage"; 

function LoginPage({ loginHandler }) {
  const [showPassword, setShowPassword] = useState(false);
  const [token, setToken] = useState(null);
  const [alertMessage, setAlertMessage] = useState(null);
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const [formData, setFormData] = useState({
    phone: "",
    password: ""
  });
  const navigate = useNavigate();

  const togglePassword = () => setShowPassword(!showPassword);

  useEffect(() => {
    setToken(Cookies.get("authToken"));
  }, []);

  const showPopupMessage = (message) => {
    setAlertMessage(message);
  };

  const closePopupMessage = () => {
    setAlertMessage(null);
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [id]: value
    }));
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleLogin();
    }
  };

  const handleLogin = async () => {
    if (isLoggingIn) return;

    // Validate inputs
    if (!formData.phone || !formData.password) {
      showPopupMessage("Please enter both phone number and password");
      return;
    }

    setIsLoggingIn(true);

    const token = Cookies.get("authToken");
    const userId = Cookies.get("userId");

    try {
      const response = await fetch(`${config.API_URL}/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ 
          phone_number: formData.phone, 
          password: formData.password, 
          token, 
          userId 
        }),
      });

      if (response.ok) {
        const data = await response.json();

        if (!data.token) {
          const user_id = data.user_id;
          navigate("/OTPPage", { state: { user_id } });
        } else {
          Cookies.set("authToken", data.token, { expires: 365, path: "/" });
          Cookies.set("userType", data.user_type, { expires: 365, path: "/" });
          Cookies.set("userId", data.user_id || userId, { expires: 365, path: "/" });
          loginHandler(data.token, data.user_type, data.user_id || userId);

          if (data.user_type === "management") {
            navigate("/management-dashboard");
          } else if (["TSO Online", "Online TSO"].includes(data.user_type)) {
            navigate("/dashboard");
          } else {
            navigate("/c-dashboard");
          }
        }
      } else {
        const errorData = await response.json();
        showPopupMessage(
          errorData.error ||
            "Login failed. Please check your credentials and try again."
        );
      }
    } catch (error) {
      console.error("Failed to fetch:", error);
      showPopupMessage("Network error. Please try again later.");
    } finally {
      setIsLoggingIn(false);
    }
  };

  return (
    <div className="login-page">
      {alertMessage && (
        <PopupMessage message={alertMessage} onClose={closePopupMessage} />
      )}

      <div className="container">
        <div className="welcome-section">
          <h1>Welcome to Rajida</h1>
          <p className="quote">Let's login to Account</p>
        </div>
        <div className="login-form">
          <h2>Quick Support Assistance</h2>
          {/* Phone Number Input Field */}
          <div className="input-container">
            <label htmlFor="phone">Phone Number</label>
            <div className="input-wrapper">
              <input 
                id="phone" 
                type="text" 
                className="input-field" 
                value={formData.phone}
                onChange={handleInputChange}
                onKeyPress={handleKeyPress}
              />
            </div>
          </div>
          {/* Password Input Field */}
          <div className="input-container password-container">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type={showPassword ? "text" : "password"}
              className="input-field"
              value={formData.password}
              onChange={handleInputChange}
              onKeyPress={handleKeyPress}
            />
            <span className="toggle-password" onClick={togglePassword}>
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </span>
          </div>
          {/* Login Button */}
          <button 
            onClick={handleLogin} 
            disabled={isLoggingIn}
            className={isLoggingIn ? "loading" : ""}
          >
            {isLoggingIn ? "Logging In..." : "Log In"}
          </button>
          {/* Forgot Password */}
          <div className="forgot-password">Forgot Password?</div>
          {/* Social Login Buttons */}
          <div className="social-buttons">
            <div className="social-button google">
              <FaGoogle /> Google
            </div>
            <div className="social-button facebook">
              <FaFacebook /> Facebook
            </div>
            <div className="social-button apple">
              <FaApple /> Apple
            </div>
          </div>
          {/* Powered By Section */}
          <div className="powered-by">Powered by Rajida</div>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;